import { memo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import { SideDoorIcon } from '@client/images/logos/SideDoorIcon';
import { useDispatch } from '@client/hooks/redux.hooks';
import { startToggleImpersonate } from '@client/slices/helpers/session.reducer';
import { Button } from '@client/components/common/Button';
import { appBar } from '@client/theme/mixins';
import { useIsMobile } from '@client/hooks/dom.hooks';

const useStyles = makeStyles()((theme) => ({
  appBar: {
    ...appBar(theme),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey[200],
  },
  toolbar: {
    justifyContent: 'space-between',
    width: '100%',
  },
  navLogo: {
    [theme.breakpoints.up('md')]: {
      visibility: 'hidden',
    },
  },
  appBarButtons: {
    '& > button:not(:last-of-type)': {
      marginRight: theme.spacing(1),
    },
  },
}));

interface HeaderProps {
  readonly isImpersonating: boolean;
  readonly handleClose: () => void;
}

export const Header = memo<HeaderProps>(({ isImpersonating, handleClose }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const handleUnimpersonate = useCallback(() => dispatch(startToggleImpersonate()), [dispatch]);

  if (!isMobile && !isImpersonating) {
    return null;
  }

  return (
    <AppBar
      className={classes.appBar}
      position="static"
      color="inherit"
    >
      <Toolbar className={classes.toolbar}>
        <IconButton
          size="xlarge"
          component={Link}
          to="/home"
          onClick={handleClose}
          className={classes.navLogo}
          edge="start"
        >
          <SideDoorIcon />
        </IconButton>

        <div className={classes.appBarButtons}>
          {Boolean(isImpersonating) && (
            <Button
              scope="unimpersonate-button"
              onClick={handleUnimpersonate}
              size="small"
            >
              Unpersonate
            </Button>
          )}

          <IconButton
            onClick={handleClose}
            size="xlarge"
            edge="end"
          >
            <CloseIcon />
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
});
